import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Dilucion/editDilucion`, method: 'POST', body: values, token: token})
}
